module.exports = __webpack_public_path__ + "static/media/adriana-bettamio-tesser.76df7798.png";